<div class="transport-routinglog-inspector">
    <div class="transport-routinglog-inspector-layout" [formGroup]="inputFormGroup">
        <mat-form-field style="grid-row: 1; grid-column: 1 / span 2;" appearance="fill">
          <mat-label>{{'routing log key'| translate:['tmc-yard.widgets.transport-routinglog-inspector.transport-log-key', translationService.language]}}</mat-label>
            <input matInput name="transportLogKey" formControlName="transportLogKey">
        </mat-form-field>
        <div style="grid-row: 2; grid-column: 1">
            {{'username' | translate:['tmc-yard.entity.routing-log.username', translationService.language]}}
        </div>
        <div style="grid-row: 2; grid-column: 2">
            {{details.username}}
        </div>
        <div style="grid-row: 3; grid-column: 1">
            {{'timestamp' | translate:['tmc-yard.entity.routing-log.timestamp', translationService.language]}}
        </div>
        <div style="grid-row: 3; grid-column: 2">
            {{details.timestamp}}
        </div>
        <div style="grid-row: 4; grid-column: 1">
            {{'activity type' | translate:['tmc-yard.entity.routing-log.activity-type', translationService.language]}}
        </div>
        <div style="grid-row: 4; grid-column: 2">
            {{details.activityType}}
        </div>
        <div style="grid-row: 5; grid-column: 1">
            {{'execution type' | translate:['tmc-yard.entity.routing-log.execution-type', translationService.language]}}
        </div>
        <div style="grid-row: 5; grid-column: 2">
            {{details.executionType}}
        </div>
        <div style="grid-row: 6; grid-column: 1">
            {{'note' | translate:['tmc-yard.entity.routing-log.note', translationService.language]}}
        </div>
        <div style="grid-row: 6; grid-column: 2">
            {{details.note}}
        </div>
    </div>
</div>
